import { defineAsyncComponent } from 'vue'
import type { Component } from 'vue'
import type { ShowOptions } from '@/components/multiDialogsProvider/types'

const Common = defineAsyncComponent(() => import('./common.vue'))
const selectAvatarNew = defineAsyncComponent(
  () => import('./selectAvatarDialogNew.vue')
)
const ConfigForm = defineAsyncComponent(() => import('./configForm.vue'))
type keys =
  | 'modalProps'
  | 'componentProps'
  | 'hideMask'
  | 'maskClosable'
  | 'componentKey'

interface DialogComponent extends Pick<ShowOptions, keys> {
  body: Component
}

export const dialogComponents: Record<string, DialogComponent> = {
  common: {
    body: Common
  },
  selectAvatarNew: {
    body: selectAvatarNew
  },
  configForm: {
    body: ConfigForm
  }
}
